module.exports = __webpack_public_path__ + "img/socket.436354b0.jpg";